import { _post, _get, _delete } from "./Axios";

export default class KpiApi {
  static get(id = null) {
    if (id == null) {
      return _get("kpi/");
    } else {
      return _get("kpi/" + id);
    }
  }
  static getbyparam(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("kpi/?" + params);
  }
  static post(data) {
    return _post("kpi/", data);
  }
  static create(data) {
    return _post("kpi/", data);
  }
  static update(id, data) {
    return _post("kpi/" + id, data);
  }
  static delete(id) {
    return _delete("kpi/" + id);
  }

  static getNew(id = null) {
    if (id == null) {
      return _get("kpi-new/");
    } else {
      return _get("kpi-new/" + id);
    }
  }
  static getByParamsNew(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("kpi-new/?" + params);
  }
  static createNew(data) {
    return _post("kpi-new/", data);
  }
  static updateNew(data) {
    return _post("kpi-new/update", data);
  }
  static deleteNew(id) {
    return _delete("kpi-new/"+ id);
  }

  static updateAdditionalNew(id, data) {
    return _post("kpi-new/additional/update/"+ id, data);
  }

  static deleteAdditionalNew(data) {
    return _post("kpi-new/additional/delete", data);
  }

  static udateStatusAdditionalNew(data) {
    return _post("kpi-new/additional/ubah-status", data);
  }
}
